import levenshtein from 'js-levenshtein';

export class StringUtils {
  public static STRING_IDENTICAL_THRESHOLD_PERCENTAGE = 60;

  private static GSM =
    '@£$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞ^{}[~]|€ÆæßÉ!"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà';

  public static simplifyString(str: string): string {
    // make string more simple to analyse
    try {
      return str.replace(/ /g, '').toLowerCase();
    } catch (e) {
      return '';
    }
  }

  public static removeAllNonNumberCharacters(str: string): string {
    // make string more simple to analyse
    try {
      return str.replace(/\D/g, '');
    } catch (e) {
      return '';
    }
  }

  public static getAllUniqueCharsNotInGSM(text: string): string {
    const simpleText = StringUtils.simplifyString(text);

    if (!simpleText?.length) {
      return '';
    }

    const notGsmCharSet = new Set<string>();

    for (const char of simpleText) {
      if (!StringUtils.GSM.includes(char)) {
        notGsmCharSet.add(char);
      }
    }

    return Array.from(notGsmCharSet).join('');
  }

  public static isEmailValid(email: string): boolean {
    return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email.toLowerCase()
    );
  }

  public static generateFullName(name: string, surname: string): string {
    let fullName = name || '';

    if (fullName?.length > 0 && surname) {
      fullName += ' ';
    }

    if (surname) {
      fullName += surname;
    }

    return fullName;
  }

  public static encodeBase64(str: string): string {
    if (!str?.length) {
      return str;
    }

    return btoa(unescape(encodeURIComponent(str)));
  }

  public static decodeBase64(str: string): string {
    if (!str?.length) {
      return str;
    }

    return decodeURIComponent(escape(atob(str)));
  }

  public static shortenString(
    str: string,
    maxLength = 15,
    suffix = '...'
  ): string {
    if (!str?.length || str?.length <= maxLength) {
      return str;
    } else {
      return `${str.substr(0, maxLength - suffix?.length)}${suffix}`;
    }
  }

  public static calculateIdenticalPercentageOfTwoString(
    txt1: string,
    txt2: string
  ): number {
    if (!txt1 && !txt2) {
      return 100;
    }

    if (!txt1 || !txt2) {
      return 0;
    }

    const distance = levenshtein(
      this.simplifyString(txt1),
      this.simplifyString(txt2)
    );
    const maxDistance = Math.max(txt1.length, txt2.length);

    return ((maxDistance - distance) * 100) / maxDistance;
  }
}
